import React, {createContext, useEffect, useState} from "react";
import {fetchQuery, graphql} from "relay-runtime";
import {relayGuestEnvironment} from "@/RelayEnvironment";
import {logger} from "@/Logger";
import {useSelector} from "react-redux";
import {getLocale, selectAppIsInitialized, selectLocale} from "@/Redux/App/AppReducer";

export const TranslationContext = createContext(null);

export const TranslationProvider = ({children}) => {
    const [translations, setTranslations] = useState(null);
    const language = useSelector(selectLocale) ?? getLocale();

    const isAppInitialized = useSelector((state) =>
        selectAppIsInitialized(state),
    );

    useEffect(() => {
        const loadTranslations = async () => {

            if (!isAppInitialized) {
                return;
            }

            try {
                const res = await fetchQuery(
                    relayGuestEnvironment(),
                    graphql`
                        query TranslationProviderQuery($lang: String!, $prefixes: [String]) {
                            translationList(lang: $lang, prefixes: $prefixes) {
                                translations {
                                    component
                                    text
                                }
                            }
                        }
                    `,
                    {lang: language?.locale ?? language, prefixes: ["CRW6.sidebar", "CRW6.general", "CRW6.messages", "CRW6.login", "CRW6.translations", "CRW6.groupReservation", "CRW6.moveBooking"]}
                ).toPromise();

                const temp = {};
                res?.translationList?.translations?.forEach((translation) => {
                    temp[translation.component] = translation.text;
                });
                setTranslations(temp);
            } catch (error) {
                logger.error(error);
            }
        };

        loadTranslations();
    }, [isAppInitialized, language]);

    return (
        <TranslationContext.Provider value={{"translations": translations, "setTranslations": setTranslations}}>
            {children}
        </TranslationContext.Provider>
    );
};